export enum RapidDeployRoute {
  GATEWAY = 'gateway',
  VIDEO_SOURCES = 'video-sources',
  DEPLOY = 'configure',
}
